import { io } from "socket.io-client";

export const socket = io(process.env.REACT_APP_API_URL || "http://localhost:8080", {
  autoConnect: true,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
});